import { EBEPaymentMethodsName } from '../../../../contracts';

// Stripe APMs whose own `<PaymentElement>` does NOT surface an email input, so
// we render a `<LinkAuthenticationElement>` above it to collect the receipt
// email. (The historical name reads as the inverse of what it does — these are
// the methods that DO get a rendered email field.)
//
// Bizum (ACDEV-26325), Swish (ACDEV-25495) and MB WAY are included for the same
// reason: unlike ideal/eps/bancontact their element collects no email (MB WAY
// authenticates via phone number), so without this they would take no receipt
// email at all — matching v3, which already requires email for every generic
// Stripe APM.
export const APMS_WITH_RENDERED_EMAIL_FIELD: EBEPaymentMethodsName[] = [
  EBEPaymentMethodsName.card,
  EBEPaymentMethodsName.link,
  EBEPaymentMethodsName.ideal,
  EBEPaymentMethodsName.cashapp,
  EBEPaymentMethodsName.affirm,
  EBEPaymentMethodsName.eps,
  EBEPaymentMethodsName.bancontact,
  EBEPaymentMethodsName.bizum,
  EBEPaymentMethodsName.swish,
  EBEPaymentMethodsName.mbway,
  EBEPaymentMethodsName.amazonPay,
  EBEPaymentMethodsName.krCard,
  EBEPaymentMethodsName.payco,
  EBEPaymentMethodsName.samsungPay,
  EBEPaymentMethodsName.naverPay,
  EBEPaymentMethodsName.klarna,
  EBEPaymentMethodsName.upi,
];

export const shouldRenderStripeEmailField = (paymentMethodName?: string): boolean =>
  APMS_WITH_RENDERED_EMAIL_FIELD.includes(paymentMethodName as EBEPaymentMethodsName);
